/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, isRef as _isRef } from "vue";
var _hoisted_1 = {
  class: "patrol-scheme-detail"
};
var _hoisted_2 = {
  class: "list-detail"
};
var _hoisted_3 = {
  class: "list-detail-block"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "基本信息")], -1);
var _hoisted_5 = {
  class: "detail-item-content"
};
var _hoisted_6 = {
  class: "content-item"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "计划类型:", -1);
var _hoisted_8 = {
  class: "content-item-value"
};
var _hoisted_9 = {
  class: "detail-item-content"
};
var _hoisted_10 = {
  class: "content-item"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "巡保内容:", -1);
var _hoisted_12 = {
  class: "content-item-value"
};
var _hoisted_13 = {
  class: "detail-item-content"
};
var _hoisted_14 = {
  class: "content-item"
};
var _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "巡保人:", -1);
var _hoisted_16 = {
  class: "content-item-value"
};
var _hoisted_17 = {
  class: "detail-item-content"
};
var _hoisted_18 = {
  class: "content-item"
};
var _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "任务状态:", -1);
var _hoisted_20 = {
  key: 0,
  class: "content-item-value content-item-status-complete"
};
var _hoisted_21 = {
  key: 1,
  class: "content-item-status-ing content-item-value"
};
var _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "进行中", -1);
var _hoisted_23 = [_hoisted_22];
var _hoisted_24 = {
  key: 2,
  class: "content-item-status-cancel content-item-value"
};
var _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "已取消", -1);
var _hoisted_26 = [_hoisted_25];
var _hoisted_27 = {
  key: 3,
  class: "content-item-status-expect content-item-value"
};
var _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "已逾期", -1);
var _hoisted_29 = [_hoisted_28];
var _hoisted_30 = {
  key: 4,
  class: "content-item-status-ing content-item-value"
};
var _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "未处理", -1);
var _hoisted_32 = [_hoisted_31];
var _hoisted_33 = {
  class: "detail-item-content"
};
var _hoisted_34 = {
  class: "content-item"
};
var _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "任务类型:", -1);
var _hoisted_36 = {
  class: "content-item-value"
};
var _hoisted_37 = {
  class: "detail-item-content"
};
var _hoisted_38 = {
  class: "content-item"
};
var _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "开始时间:", -1);
var _hoisted_40 = {
  class: "content-item-value"
};
var _hoisted_41 = {
  class: "detail-item-content"
};
var _hoisted_42 = {
  class: "content-item"
};
var _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "结束时间:", -1);
var _hoisted_44 = {
  class: "content-item-value"
};
var _hoisted_45 = {
  class: "detail-item-content"
};
var _hoisted_46 = {
  class: "content-item"
};
var _hoisted_47 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "计划巡检时间:", -1);
var _hoisted_48 = {
  class: "content-item-value"
};
var _hoisted_49 = {
  class: "detail-item-content"
};
var _hoisted_50 = {
  class: "content-item"
};
var _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "审核人:", -1);
var _hoisted_52 = {
  class: "content-item-value"
};
var _hoisted_53 = {
  class: "detail-item-content"
};
var _hoisted_54 = {
  class: "content-item"
};
var _hoisted_55 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备名称:", -1);
var _hoisted_56 = {
  class: "content-item-value"
};
var _hoisted_57 = {
  class: "detail-item-content"
};
var _hoisted_58 = {
  class: "content-item"
};
var _hoisted_59 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备类型:", -1);
var _hoisted_60 = {
  class: "content-item-value"
};
var _hoisted_61 = {
  class: "detail-item-content"
};
var _hoisted_62 = {
  class: "content-item"
};
var _hoisted_63 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备位置:", -1);
var _hoisted_64 = {
  class: "content-item-value"
};
var _hoisted_65 = {
  class: "detail-item-content"
};
var _hoisted_66 = {
  class: "content-item"
};
var _hoisted_67 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "创建时间:", -1);
var _hoisted_68 = {
  class: "content-item-value"
};
var _hoisted_69 = {
  class: "bottom-submit"
};
var _hoisted_70 = {
  class: "popup-content"
};
var _hoisted_71 = {
  key: 0
};
var _hoisted_72 = {
  key: 1
};
var _hoisted_73 = {
  class: "popup-btn"
};
import { delPatrolGuard, cancelPatrolGuard, getPatrolGuardDetail } from '@/service/patrolGuard/index';
import { showToast } from 'vant';
import './detail.less';
import './common.less';
export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var _route$query = route.query,
      id = _route$query.id,
      deviceId = _route$query.deviceId;
    var radioModalShow = ref(false);
    var customPopupType = ref();
    var detailDefault = ref({
      deviceId: 0,
      createTime: '',
      inspectionDeviceList: [{
        deviceName: '',
        deviceTypeCode: '',
        deviceAddr: ''
      }],
      inspectionTaskRuleList: [{
        status: null,
        inspectionItemInfoList: [{
          inspectionItemInfo: '',
          inspectionTaskDesc: '',
          inspectionUserName: ''
        }]
      }]
    });
    var detail = ref(detailDefault.value);
    var delLoading = ref(false);
    var cancelloading = ref(false);
    // const onClickLeft = () => {
    //   router.back();
    // };
    var onClickCancel = function onClickCancel() {
      radioModalShow.value = true;
      customPopupType.value = '-1';
    };
    var onClickDel = function onClickDel() {
      radioModalShow.value = true;
      customPopupType.value = '0';
    };
    var onCancel = function onCancel() {
      radioModalShow.value = false;
      if (customPopupType.value === '1' || customPopupType.value === '0') {
        //
      }
    };
    var onOk = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(customPopupType.value == '-1')) {
                _context.next = 18;
                break;
              }
              _context.prev = 1;
              cancelloading.value = true;
              // 取消;
              _context.next = 5;
              return cancelPatrolGuard({
                id: Number(id),
                status: -1
              });
            case 5:
              radioModalShow.value = false;
              cancelloading.value = false;
              getDetail();
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);
            case 13:
              _context.prev = 13;
              cancelloading.value = false;
              return _context.finish(13);
            case 16:
              _context.next = 33;
              break;
            case 18:
              _context.prev = 18;
              delLoading.value = true;
              // 删除
              delLoading.value = true;
              _context.next = 23;
              return delPatrolGuard(Number(id));
            case 23:
              radioModalShow.value = false;
              router.back();
              _context.next = 30;
              break;
            case 27:
              _context.prev = 27;
              _context.t1 = _context["catch"](18);
              console.log(_context.t1);
            case 30:
              _context.prev = 30;
              delLoading.value = false;
              return _context.finish(30);
            case 33:
              radioModalShow.value = false;
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 10, 13, 16], [18, 27, 30, 33]]);
      }));
      return function onOk() {
        return _ref.apply(this, arguments);
      };
    }();
    var onComplete = function onComplete() {
      if (detail.value.taskType == 1) {
        router.push({
          path: '/patrolGuard/complete',
          query: {
            id: deviceId,
            taskItemId: detail.value.taskItemId
          }
        });
      } else if (detail.value.taskType == 0) {
        router.push({
          path: '/addPatrolScheme',
          query: {
            id: deviceId,
            taskItemId: detail.value.taskItemId
          }
        });
      }
    };
    var getDetail = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              showToast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
              });
              _context2.next = 4;
              return getPatrolGuardDetail({
                id: id,
                deviceId: deviceId
              });
            case 4:
              data = _context2.sent;
              if (data.deviceId) {
                detail.value = data;
              } else {
                detail.value = detailDefault.value;
              }
            case 6:
              _context2.prev = 6;
              setTimeout(function () {
                showToast.clear();
              });
              return _context2.finish(6);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0,, 6, 9]]);
      }));
      return function getDetail() {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted(function () {
      getDetail();
    });
    return function (_ctx, _cache) {
      var _unref$inspectionTask, _unref$inspectionTask2, _unref$inspectionTask3, _unref$inspectionTask4, _unref$inspectionTask5, _unref$inspectionTask6, _unref$inspectionTask7, _unref$inspectionTask8, _unref$inspectionTask9, _unref$inspectionTask10, _unref$inspectionTask11, _unref$inspectionTask12, _unref$inspectionDevi, _unref$inspectionDevi2, _unref$inspectionDevi3, _unref$inspectionTask13, _unref$inspectionTask14, _unref$inspectionTask15, _unref$inspectionTask16, _unref$inspectionTask17, _unref$inspectionTask18;
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(detail).taskTypeDesc || '--'), 1)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(((_unref$inspectionTask = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask === void 0 || (_unref$inspectionTask = _unref$inspectionTask.inspectionItemInfoList[0]) === null || _unref$inspectionTask === void 0 ? void 0 : _unref$inspectionTask.inspectionItemInfo) || '--'), 1)])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(((_unref$inspectionTask2 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask2 === void 0 || (_unref$inspectionTask2 = _unref$inspectionTask2.inspectionItemInfoList[0]) === null || _unref$inspectionTask2 === void 0 ? void 0 : _unref$inspectionTask2.inspectionUserName) || '--'), 1)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, ((_unref$inspectionTask3 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask3 === void 0 ? void 0 : _unref$inspectionTask3.inspectionItemInfoList[0].status) == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 已完成 ")) : _createCommentVNode("", true), ((_unref$inspectionTask4 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask4 === void 0 ? void 0 : _unref$inspectionTask4.inspectionItemInfoList[0].status) == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23)) : _createCommentVNode("", true), ((_unref$inspectionTask5 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask5 === void 0 ? void 0 : _unref$inspectionTask5.inspectionItemInfoList[0].status) == -1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26)) : _createCommentVNode("", true), ((_unref$inspectionTask6 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask6 === void 0 ? void 0 : _unref$inspectionTask6.inspectionItemInfoList[0].status) == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29)) : _createCommentVNode("", true), ((_unref$inspectionTask7 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask7 === void 0 ? void 0 : _unref$inspectionTask7.inspectionItemInfoList[0].status) == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", _hoisted_36, _toDisplayString(((_unref$inspectionTask8 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask8 === void 0 ? void 0 : _unref$inspectionTask8.inspectionTaskDesc) || '--'), 1)])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", _hoisted_40, _toDisplayString(((_unref$inspectionTask9 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask9 === void 0 ? void 0 : _unref$inspectionTask9.startTime) || '--'), 1)])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, _toDisplayString(((_unref$inspectionTask10 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask10 === void 0 ? void 0 : _unref$inspectionTask10.endTime) || '--'), 1)])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", _hoisted_48, _toDisplayString(((_unref$inspectionTask11 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask11 === void 0 ? void 0 : _unref$inspectionTask11.inspectionTime) || '--'), 1)])]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_hoisted_51, _createElementVNode("div", _hoisted_52, _toDisplayString(((_unref$inspectionTask12 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask12 === void 0 ? void 0 : _unref$inspectionTask12.assessorUserName) || '--'), 1)])]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, _toDisplayString(((_unref$inspectionDevi = _unref(detail)['inspectionDeviceList'][0]) === null || _unref$inspectionDevi === void 0 ? void 0 : _unref$inspectionDevi.deviceName) || '--'), 1)])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_hoisted_59, _createElementVNode("div", _hoisted_60, _toDisplayString(((_unref$inspectionDevi2 = _unref(detail)['inspectionDeviceList'][0]) === null || _unref$inspectionDevi2 === void 0 ? void 0 : _unref$inspectionDevi2.deviceTypeCode) || '--'), 1)])]), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_hoisted_63, _createElementVNode("div", _hoisted_64, _toDisplayString(((_unref$inspectionDevi3 = _unref(detail)['inspectionDeviceList'][0]) === null || _unref$inspectionDevi3 === void 0 ? void 0 : _unref$inspectionDevi3.deviceAddr) || '--'), 1)])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_hoisted_67, _createElementVNode("div", _hoisted_68, _toDisplayString(_unref(detail).createTime), 1)])])])]), _createElementVNode("div", _hoisted_69, [_createVNode(_component_van_button, {
        plain: "",
        type: "primary",
        class: "footer-user-action",
        onClick: onClickDel,
        loading: _unref(delLoading)
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 删除 ")];
        }),
        _: 1
      }, 8, ["loading"]), ((_unref$inspectionTask13 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask13 === void 0 ? void 0 : _unref$inspectionTask13.inspectionItemInfoList[0].status) == 1 || ((_unref$inspectionTask14 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask14 === void 0 ? void 0 : _unref$inspectionTask14.inspectionItemInfoList[0].status) == 0 || ((_unref$inspectionTask15 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask15 === void 0 ? void 0 : _unref$inspectionTask15.inspectionItemInfoList[0].status) == 2 ? (_openBlock(), _createBlock(_component_van_button, {
        key: 0,
        plain: "",
        type: "primary",
        class: "footer-user-action",
        onClick: onClickCancel,
        loading: _unref(cancelloading)
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 取消 ")];
        }),
        _: 1
      }, 8, ["loading"])) : _createCommentVNode("", true), ((_unref$inspectionTask16 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask16 === void 0 ? void 0 : _unref$inspectionTask16.inspectionItemInfoList[0].status) == 1 || ((_unref$inspectionTask17 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask17 === void 0 ? void 0 : _unref$inspectionTask17.inspectionItemInfoList[0].status) == 0 || ((_unref$inspectionTask18 = _unref(detail)['inspectionTaskRuleList'][0]) === null || _unref$inspectionTask18 === void 0 ? void 0 : _unref$inspectionTask18.inspectionItemInfoList[0].status) == 2 ? (_openBlock(), _createBlock(_component_van_button, {
        key: 1,
        type: "primary",
        onClick: onComplete,
        class: "footer-user-action"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 完成 ")];
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_van_popup, {
        show: _unref(radioModalShow),
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(radioModalShow) ? radioModalShow.value = $event : null;
        }),
        position: "bottom",
        class: "filter-modal-show"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_70, [_unref(customPopupType) === '-1' ? (_openBlock(), _createElementBlock("span", _hoisted_71, "确定要取消吗？")) : _createCommentVNode("", true), _unref(customPopupType) === '0' ? (_openBlock(), _createElementBlock("span", _hoisted_72, "确定要删除吗？")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_73, [_createVNode(_component_van_button, {
            type: "default",
            onClick: onCancel
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("取消")];
            }),
            _: 1
          }), _createVNode(_component_van_button, {
            type: "primary",
            onClick: onOk
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("确定")];
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
});